import type { TenantConfig } from '@/types/TenantConfig'

export const test: TenantConfig = {
  ticketureTheme: true,
  teaserImageSize: {
    width: 300,
    height: 300,
  },
  // Useful to force failed payments, even for digital wallets.
  // allowedCardBrands: ['amex'],
  componentOptions: {
    checkoutRoute: {
      stripeWallets: true,
    },
  },
}
